<template>
  <CFooter class="footer">
    <div>
      <span>&copy; 2025 Farm Bits.</span>
      <span class="ms-1">All rights reserved.</span>
    </div>
  </CFooter>
</template>

<script lang="ts" setup>
</script>

<style scoped>
</style>
